import { isStreamOneTimeTariff } from '../../tariffTypes'

type UseStreamOneTimeLinkFormParams = {
  typeWatch: string | null | undefined
  selectedTariff?: ICourseTariff | null
}

/**
 * Оркестрация stream_one_time в create-link: isActive для UI/условий модалки.
 * Цена задаётся в StreamOneTimeLinkFields и гидратится при смене тарифа.
 */
export const useStreamOneTimeLinkForm = ({
  typeWatch,
  selectedTariff,
}: UseStreamOneTimeLinkFormParams) => {
  const isActive =
    typeWatch === 'course' && isStreamOneTimeTariff(selectedTariff?.type)

  return { isActive }
}
